module.exports = __webpack_public_path__ + "img/bank-bcp.89e8ed76.png";